import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { resultQueryFn, resultMutationFn } from '@/shared/utils/queryHelpers';
import { queryKeys } from '@/shared/utils/queryKeys';
import type { UpdateSettingsRequest, UserSettings } from './types';
import { fetchSettings, updateSettings } from './api';

export function useSettings() {
  return useQuery({
    queryKey: queryKeys.settings.all,
    queryFn: resultQueryFn(fetchSettings),
    staleTime: 5 * 60_000,
  });
}

export function useUpdateSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: resultMutationFn(updateSettings),
    onSuccess: (data) => {
      queryClient.setQueryData(queryKeys.settings.all, data);
    },
  });
}
